import { render, staticRenderFns } from "./PassUpdateForm.vue?vue&type=template&id=a926f1e6&"
import script from "./PassUpdateForm.vue?vue&type=script&lang=js&"
export * from "./PassUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports